// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Nrve","list":"styles_list__1Y1yy"};